/* NAIZOR — interacciones de las secciones nz-* */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var pending = [];
  var io = null;

  function reveal(el) {
    el.classList.add('nz-visible');
    if (io) io.unobserve(el);
    var i = pending.indexOf(el);
    if (i > -1) pending.splice(i, 1);
  }

  // Red de seguridad: revela lo que ya esté en pantalla aunque el observador no avise
  function sweep() {
    if (!pending.length) return;
    var vh = window.innerHeight;
    pending.slice().forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.94 && r.bottom > 0 && (r.width > 0 || r.height > 0)) reveal(el);
    });
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.nz-reveal, .nz-reveal--mask, .nz-hero');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('nz-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) reveal(e.target); });
      }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) {
      if (el.classList.contains('nz-visible')) return;
      pending.push(el);
      io.observe(el);
    });
    sweep();
  }

  function initParallax() {
    if (reduce) return;
    var items = [];
    document.querySelectorAll('[data-nz-parallax]').forEach(function (el) {
      items.push({ el: el, k: parseFloat(el.getAttribute('data-nz-parallax')) || 0 });
    });
    if (!items.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (it) {
        if (!it.k) return;
        var r = it.el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var center = r.top + r.height / 2 - vh / 2;
        it.el.style.transform = 'translate3d(0,' + (center * -it.k / 100).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    // Captura en document: Horizon desplaza dentro de .page-wrapper, no en window
    document.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true, capture: true });
    window.addEventListener('resize', update);
    update();
  }

  function initLightbox() {
    var triggers = document.querySelectorAll('[data-nz-zoom]');
    if (!triggers.length) return;
    var box = document.createElement('div');
    box.className = 'nz-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML = '<button type="button" aria-label="Close">&times;</button><img alt="">';
    document.body.appendChild(box);
    var img = box.querySelector('img');
    function close() { box.classList.remove('is-open'); }
    box.addEventListener('click', function (e) { if (e.target !== img) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    triggers.forEach(function (t) {
      t.addEventListener('click', function () {
        img.src = t.getAttribute('data-nz-zoom');
        img.alt = t.getAttribute('data-nz-alt') || '';
        box.classList.add('is-open');
      });
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); } });
    });
  }

  // Botón «Copy» de la barra del código (bloque nz-promo-code): un clic copia el código al portapapeles
  function initCopy() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-nz-copy]') : null;
      if (!btn) return;
      var code = btn.getAttribute('data-nz-copy') || '';
      var label = btn.querySelector('.nz-promo__btn-label') || btn;
      var live = btn.parentElement ? btn.parentElement.querySelector('.nz-promo__live') : null;
      function done() {
        if (!btn.hasAttribute('data-nz-label')) btn.setAttribute('data-nz-label', label.textContent);
        var copied = btn.getAttribute('data-nz-copied') || 'Copied!';
        label.textContent = copied;
        btn.classList.add('is-copied');
        if (live) live.textContent = copied + ' ' + code;
        clearTimeout(btn._nzT);
        btn._nzT = setTimeout(function () {
          label.textContent = btn.getAttribute('data-nz-label');
          btn.classList.remove('is-copied');
          if (live) live.textContent = '';
        }, 2200);
      }
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '0';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(ta);
        done();
      }
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback);
      else fallback();
    });
  }

  // Botón «Cookie preferences» del pie: reabre el panel de cookies de Shopify
  function initCookiePrefs() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-nz-cookie-prefs]') : null;
      if (!btn) return;
      e.preventDefault();
      var pb = window.privacyBanner;
      if (pb && typeof pb.showPreferences === 'function') {
        pb.showPreferences();
      } else if (pb && typeof pb.loadBanner === 'function') {
        var loading = pb.loadBanner();
        var open = function () { if (typeof pb.showPreferences === 'function') pb.showPreferences(); };
        if (loading && typeof loading.then === 'function') loading.then(open);
        else open();
      } else {
        window.location.href = '/policies/privacy-policy';
      }
    });
  }

  function init() {
    window.__nzReady = true;
    document.documentElement.classList.add('nz-js');
    initReveal();
    initParallax();
    initLightbox();
    initCopy();
    initCookiePrefs();
    var sweepTick = false;
    document.addEventListener('scroll', function () {
      if (!sweepTick) { sweepTick = true; window.requestAnimationFrame(function () { sweep(); sweepTick = false; }); }
    }, { passive: true, capture: true });
    window.addEventListener('load', sweep);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
